import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

const UI_ICON_MODE_KEY = 'ui_icon_mode';
const UISettingsContext = createContext();

const resolveInitialIconMode = () => {
  const raw = String(localStorage.getItem(UI_ICON_MODE_KEY) || '').toLowerCase();
  if (raw === 'emoji' || raw === 'svg') {
    return raw;
  }
  return 'svg';
};

export const UISettingsProvider = ({ children }) => {
  const [iconMode, setIconModeState] = useState(resolveInitialIconMode);

  useEffect(() => {
    localStorage.setItem(UI_ICON_MODE_KEY, iconMode);
  }, [iconMode]);

  const setIconMode = useCallback((mode) => {
    const normalized = String(mode || '').toLowerCase() === 'emoji' ? 'emoji' : 'svg';
    setIconModeState(normalized);
  }, []);

  const value = useMemo(() => ({ iconMode, setIconMode }), [iconMode, setIconMode]);

  return (
    <UISettingsContext.Provider value={value}>
      {children}
    </UISettingsContext.Provider>
  );
};

export const useUISettings = () => {
  const context = useContext(UISettingsContext);
  if (!context) {
    throw new Error('useUISettings must be used within UISettingsProvider');
  }
  return context;
};

